<p>For each bidding period there are two Bid Rounds. After each bid round is complete, you will have Winning Bids and Losing Bids (referred to as ‘Current Bids’ after Round 1).</p>
<p>If there are any conflicts they will be listed alongside the won bid. To resolve a conflict cancel one won bid and keep the other.</p>
<p>Winning bids (once reconciled) serve as the initial class enrollments. Your won sections are added to your Class Schedule in both “My Courses” and ConnectCarolina at the end of the bidding period. All winning bid points are lost.</p>
<p><strong>Note</strong> – if you want to take more than 6 courses in a module you need special approval from the Assistant Director & Registrar or the Program Director. Those conversations are held during Drop/Add of the respective module</p>
<p>You may perform the following activities with Won Bids:</p>
<div class="table-responsive">
    <table class="table table-hover">
        <thead class="thead-">
            <tr>
                <th> Activity </th>
                <th> Description </th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td> Cancel </td>
                <td> Delete a "winning" bid from the system, usually in order to reconcile one or more conflicts -- no points are refunded back. </td>
            </tr>            
        </tbody>
    </table>
</div>
